'use client'
import React, { useEffect, useState } from 'react'

import playerPlaceHolder from '@/assets/images/placeholder/player.png'
import MyImage from '../../myImage'
import CustomSelect from '../../customSelect'

function PlayerListChart({ matchDetail, playerData, currentTeamId, handlePlayersData }: any) {
  // *********** CONSTANTS ***********
  const [isAll, setIsAll] = useState(true)
  const [selectedBatters, setSelectedBatters] = useState<any>([])
  const [selectedBowler, setSelectedBowler] = useState<any>(null)

  const score =
    currentTeamId === matchDetail?.oTeamScoreA?.oTeam?._id
      ? matchDetail?.oTeamScoreA
      : matchDetail?.oTeamScoreB

  // ?ALL BATTERS
  const players = playerData?.aBatters?.map((p: any) => ({
    sName: p?.oBatter?.sFullName,
    nRuns: p?.nRuns,
    id: p?.iBatterId
  }))

  // ?ALL BOWLERS
  const playersSelect = playerData?.aBowlers?.map((p: any) => ({
    sLabel: p?.oBowler?.sFullName,
    sValue: p?.iBowlerId
  }))

  useEffect(() => {
    if (playerData) {
      const batterIds = playerData?.aBatters?.map((p: any) => p?.iBatterId)
      setSelectedBatters(batterIds)
      setIsAll(true)
      setSelectedBowler(null)
    }
  }, [playerData])

  // ************** FUNCTIONS *************

  // !FILTER DATA BATTER WISE
  function handlePlayer(t: any) {
    const batterIds = playerData?.aBatters?.map((p: any) => p?.iBatterId)
    if (t === 'all') {
      const newIsAll = !isAll
      setIsAll(newIsAll)
      setSelectedBatters(newIsAll ? batterIds : [])
      handlePlayersData(newIsAll ? batterIds : [], selectedBowler?.sValue || null)
    } else {
      const updatedPlayers = selectedBatters.includes(t)
        ? selectedBatters.filter((i: any) => i !== t)
        : [...selectedBatters, t]

      setIsAll(updatedPlayers.length === batterIds.length)
      setSelectedBatters(updatedPlayers)
      handlePlayersData(
        updatedPlayers.length === 0 ? [] : updatedPlayers,
        selectedBowler?.sValue || null
      )
    }
  }

  // !FILTER DATA BOWLER WISE
  function handleBowler(d: any) {
    setSelectedBowler(d)
    handlePlayersData(selectedBatters, d?.sValue || null)
  }

  return (
    <>
      <div className="w-full flex items-center justify-between mt-4 md:px-6 md:py-1 p-3 border border-tabBorder rounded-xl">
        {/* BOWLERS */}
        <div className="text-textDselected w-[125px] text-sm md:text-lg  block line-clamp-1">
          Select Bowler
        </div>
        <CustomSelect
          isSearchable
          isStatic
          isClearable
          options={playersSelect}
          controlClass="!bg-transparent !border-0 !shadow-none"
          value={selectedBowler}
          placeholder={'Choose Player'}
          getOptionLabel={(opt: any) => opt?.sLabel}
          getOptionValue={(opt: any) => opt?.sValue}
          isMedium={true}
          className=" w-[80%] md:w-[25%]"
          onChange={(e: any) => handleBowler(e)}
        />
      </div>

      <div className="w-full mt-6 rounded-xl border border-tabBorder">
        <div className="flex justify-between items-center md:py-5 py-2 md:p-6 px-3 bg-headersActive rounded-t-xl border-b dark:border-b-0 border-tabBorder">
          <div className="flex items-center gap-2">
            {/* FULL SCORE */}
            <span
              onClick={() => handlePlayer('all')}
              className={`cursor-pointer p-0.5 md:p-1 h-3 w-3 md:w-5 md:h-5 block rounded-full border ${isAll ? 'border-buttonBg' : 'border-textDselected'}`}
            >
              {isAll && (
                <span className="bg-buttonBg border border-buttonBg h-full w-full block rounded-full"></span>
              )}
            </span>
            <p className="text-sm md:text-lg font-bold text-textOffWhite">
              {score?.oTeam?.sTitle}: {score?.sScoresFull}
            </p>
          </div>
        </div>

        {/* BATTERS */}
        {players.map((p: any, i: number) => (
          <div
            key={i}
            className="flex justify-between items-center md:px-6 md:py-4 p-3 border-b border-tabBorder last:border-b-0"
          >
            <div className="flex items-center gap-2">
              <span
                onClick={() => handlePlayer(p?.id)}
                className={`cursor-pointer p-0.5 md:p-1 h-3 w-3 md:w-5 md:h-5 block rounded-full border ${selectedBatters.includes(p?.id) ? 'border-buttonBg' : 'border-textDselected'}`}
              >
                {selectedBatters.includes(p?.id) && (
                  <span className="bg-buttonBg border border-buttonBg h-full w-full block rounded-full"></span>
                )}
              </span>
              <MyImage src={playerPlaceHolder} className="rounded-full h-8 w-8" />
              <p className="text-xs md:text-base text-textOffWhite font-medium ">{p?.sName}</p>
            </div>
            <p className="text-sm md:text-lg text-textOffWhite font-bold">{p?.nRuns}</p>
          </div>
        ))}
      </div>
    </>
  )
}

export default PlayerListChart
